<div class="container-fluid mt-4 p-3 card shadow-sm">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center mb-4 fw-bold text-danger">Product Specifications</h2>
    </div>
  </div>
  <div class="row g-3">
    <div class="col-12" *ngFor="let category of specifications">
      <div class="card h-100 border-0 shadow-sm">
        <div class="card-body p-0">
          <h5 class="card-title fw-bold text-white p-3 border-bottom bg-danger ">{{ category.title }}</h5>
          <div class="table-responsive">
            <table class="table mb-0">
              <tbody>
              <tr *ngFor="let spec of category.specs">
                <td class="fw-semibold text-muted py-2" style="width: 40%;">{{ spec.name }}</td>
                <td class="text-dark py-2">{{ spec.string }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section *ngIf="otherSpecifications">
  <div class="row mt-4">
    <div class="col-12">
      <h4 class="text-center fw-bold text-dark p-2 border-bottom bg-body-secondary">
        Product Images
      </h4>
    </div>
  </div>
  <div class="row g-3 justify-content-center">
    <div class="col-auto" *ngFor="let image of productImage">
      <img [src]="image.imgurl" [alt]="image.name" class="img-fluid" style="max-width: 100%; height: auto;">
    </div>
  </div>
</section>
